import React, { useState, useEffect } from 'react';
import Navbar from '../Components/NavBarV2';
import Footer from '../Components/footer';
import { FaInfoCircle, FaStar } from 'react-icons/fa';
import './sala-re.css';
import imagenMa from '../images/log_mariscal.png'
import imagen1 from '../images/rosania4.png';
import { AiFillStar } from 'react-icons/ai'; // Importar el ícono de estrella de React Icons
import { VscChevronDown } from 'react-icons/vsc'
import lateral2 from '../images/ImagenLateralizquierda2.png'
import lateral1 from '../images/ImagenLateralizquierda3.png'


const SalaReuniones = () => {
    const [ratings, setRatings] = useState([0, 0, 0]);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 425);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 425);  // Cambia el estado si el ancho es <= 425
        };

        window.addEventListener('resize', handleResize);  // Escucha cambios de tamaño de pantalla

        // Limpia el evento cuando el componente se desmonte
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);


    const handleStarClick = (index, star) => {
        console.log(`Clicked star ${star} for index ${index}`);
        const newRatings = [...ratings];
        newRatings[index] = star;
        console.log('New ratings:', newRatings);
        setRatings(newRatings);
    };


    return (
        <div>
            <Navbar />

            <div className="sala_re-container">
                    <h3 className="card-title-office text-4xl font-bold">
                        Sala de Reuniones
                    </h3>



                <div className="grid">
                    <div className="card">
                        <h2 className='textRos'>Rosania Business Center</h2>
                        <div className="stars">
                            <AiFillStar className="star" />
                            <AiFillStar className="star" />
                            <AiFillStar className="star" />
                            <AiFillStar className="star" />
                            <AiFillStar className="star" />
                        </div>
                        <img src={imagen1} alt='imagen1' className="imagen1" onClick={() => window.location.href = '/office/pUanQ1iCYqqoujaXsJ08'} />

                    </div>

                    <div className="card">
                        <h2 className='textMar'>Mariscal Business Center</h2>
                        <div className="stars">
                            <AiFillStar className="star" />
                            <AiFillStar className="star" />
                            <AiFillStar className="star" />
                            <AiFillStar className="star" />
                            <AiFillStar className="star" />
                        </div>
                        <img src={imagenMa} alt='imagenMa' className="imagenMa" />

                    </div>
                </div>

                <button className='mas_espacios'>
                    <span style={{ display: 'flex', alignItems: 'center', color: 'black' }}>
                        MAS ESPACIOS
                        <VscChevronDown style={{ width: '30px', height: '30px', fill: 'black', marginLeft: '10px' }} />
                    </span>
                </button>

                <div>
                    <img src={lateral2} alt='lateral2' className='lateral2' />
                    <img src={lateral1} alt='lateral1' className='lateral1' />
                    <img src={lateral2} alt='lateral3' className='lateral3' />
                    <img src={lateral2} alt='lateral4' className='lateral4' />

                </div>

            </div>
        </div>
    );
};

export default SalaReuniones;
